var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpsideArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 23,
    viewBox: "0 0 40 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9148 21.8089L19.9995 4.89361L3.08425 21.8089C2.74096 22.1404 2.28116 22.3239 1.80391 22.3197C1.32666 22.3156 0.870123 22.1242 0.53264 21.7867C0.195158 21.4492 0.00372774 20.9927 -0.000419472 20.5154C-0.00456669 20.0382 0.178901 19.5784 0.510468 19.2351L18.7126 1.03293C19.054 0.691697 19.5169 0.5 19.9995 0.5C20.4822 0.5 20.9451 0.691697 21.2864 1.03293L39.4886 19.2351C39.8201 19.5784 40.0036 20.0382 39.9994 20.5154C39.9953 20.9927 39.8039 21.4492 39.4664 21.7867C39.1289 22.1242 38.6724 22.3156 38.1951 22.3197C37.7179 22.3239 37.2581 22.1404 36.9148 21.8089Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsideArrow);
export default __webpack_public_path__ + "static/media/upside-arrow.494b28547a6a18f82f1e8c88bf541d22.svg";
export { ForwardRef as ReactComponent };